<template>
  <div class="dialog" >
    <div style="height: 420px;overflow: hidden;text-align: left"  data-scrollbar>
        <div class="allItems">
            <div class="item wow fadeInUp" v-for="(item,index) in list" :key="index" :class="{'active':item.showContent}">
                <div class="one">
                    <div class="left">
                        <div class="text">
                            <p>{{item.title}}</p>
                            <p>{{item.description}}</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="lines" @click="getIndex(index)">
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div class="allCon" >
                        <div class="html">
                            <div class="html1" v-html="item.content[0]">

                            </div>
                            <div class="html1" v-html="item.content[1]">

                            </div>
                        </div>
                        <div class="btn">
                            <a href="mailto:admin@admin.com" target="_blank"> {{$t('tech').text6}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  import {getProductsUrl} from '../util/lang'
  export default {
    name: "aboutDia",
      data(){
        return{
            select:'',
            list:[]
        }
      },
    mounted(){
      Scrollbar.initAll();
        this.$nextTick(()=>{
            if(this.$i18n.locale==='en'){
                this.getList('120')
            }else{
                this.getList('20')
            }

        })
    },
      methods:{
          getList(id){
              const url = `${getProductsUrl(id)}`
              this.$axios.get(url).then(res => {
                  res.data.data.map((item)=>{
                      item.showContent=false
                      item.content=item.content.split('{nextPage}')
                  })
                  this.list=res.data.data
              })
          },
          getIndex(n){
              this.list[n].showContent=!this.list[n].showContent;
          }
      }
  }
</script>

<style lang="scss" scoped>
  .dialog{
    width:70%;
      margin: 60px auto;
      .allItems{
          width:100%;
          .item{
              width:100%;
              background:rgba(255,255,255,.2);
              cursor: pointer;
              margin-bottom: 20px;
              .one{
                  width:80%;
                  margin: 0 auto;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  padding: 30px 0;
                  flex-wrap: wrap;
                  align-items: center;
                  position: relative;
                  .left{
                      width:60%;
                      display: flex;
                      flex-direction: row;
                      p{
                          color:white;
                          transition: all 600ms;
                      }
                      .text{
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                          p:nth-child(1){
                              font-size: 20px;
                              font-family: "SourceHanSansSC-Regular";
                          }
                          p:nth-child(2){
                              font-size: 14px;
                              font-family: "DINEngschriftStd";
                              text-transform: uppercase;
                              margin-top: 10px;
                              margin-left: 20px;
                              letter-spacing: 0.5px;
                          }
                      }
                  }
                  .right{
                      width:10%;
                      transition: all 600ms;
                      .lines{
                          width:30px;
                          height:30px;
                          position: relative;
                          margin: 0 auto;
                          span{
                              display: inline-block;
                              background-color: white;
                              position: absolute;
                          }
                          span:nth-child(1){
                              left:0;
                              top:15px;
                              width:100%;
                              height:1px;
                              transition: all 600ms;
                          }
                          span:nth-child(2){
                              left:15px;
                              top:0;
                              width:1px;
                              height:100%;
                              transition: all 600ms;
                          }
                      }
                  }
                  .allCon{
                      width:100%;
                      z-index: 1000;
                      display: none;
                      border-top: 1px solid rgba(255,255,255,.2);
                      margin: 30px auto;
                      .html{
                          width:100%;
                          margin: 30px auto;
                          color:white;
                          font-size: 14px;
                          line-height: 30px;
                          font-family: "SourceHanSansSC-Regular";
                          animation: show 1s forwards linear;
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                          .html1{
                              width:45%;
                              color:white;
                          }
                      }
                      .btn{
                          width:100%;
                          display: flex;
                          flex-direction: row;
                          justify-content: flex-end;
                          margin: 30px auto;
                          animation-delay: 1s;
                          animation: show 1s forwards linear;
                          a{
                              -webkit-tap-highlight-color: rgba(0,0,0,0);
                              white-space: nowrap;
                              width:179px;
                              height:39px;
                              border:1px solid rgba(255,255,255,.4);
                              vertical-align: middle;
                              touch-action: manipulation;
                              user-select: none;
                              background-image: none;
                              line-height: 39px;
                              font-size: 14px;
                              border-radius: 0;
                              text-align: center;
                              text-decoration: none;
                              text-transform: uppercase;
                              overflow: hidden;
                              color:white;
                              cursor: pointer;
                              display: block;
                              position: relative;
                              transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);
                              &::before{
                                  display: block;
                                  position: absolute;
                                  top: 0px;
                                  right: 0px;
                                  height: 100%;
                                  width: 0px;
                                  z-index: -1;
                                  content: '';
                                  color: #000 !important;
                                  background:#FECD4A;
                                  transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);
                              }
                              &::after{
                                  content: "";
                                  position: absolute;
                                  height: 0%;
                                  left: 50%;
                                  top: 50%;
                                  width: 150%;
                                  z-index: -1;
                                  -webkit-transition: all 0.75s ease 0s;
                                  -moz-transition: all 0.75s ease 0s;
                                  -o-transition: all 0.75s ease 0s;
                                  transition: all 0.75s ease 0s;
                              }
                              &:hover{
                                  color:white;
                                  border-color: #FECD4A;
                              }
                              &:hover::before{
                                  left: 0%;
                                  right: auto;
                                  width: 100%;
                              }
                              &:hover::after{
                                  height: 450%;
                              }
                          }
                      }
                      @keyframes show {
                          from{
                              opacity: 0;
                          }
                          to{
                              opacity: 1;
                          }
                      }
                  }
              }
              &:hover{
                  .one{
                       .left{
                          .text{
                              p{
                                  color:#FECD4A;
                              }
                          }
                       }
                  }
              }
          }
          .active{
              .one{
                  .right{
                      .lines{
                          span:nth-child(1){
                              transform: rotate(45deg);
                          }
                          span:nth-child(2){
                              transform: rotate(-135deg);
                          }
                      }
                  }
                  .allCon{
                      display: block;
                  }
              }
          }
      }
      @media screen and (max-width: 1440px){
          width:90%;
      }
      @media screen and (max-width: 1000px){
      .allItems{
          .item{
              .one{
                  .left{
                      width:80%;
                  }
              }
          }
      }
      }
  }
</style>
